import { Link } from "react-router-dom";
import { MessageCircle, Phone, FileText } from "lucide-react";
import { COMPANY, whatsappLink } from "@/data/site";
import { trackWhatsAppClick, trackPhoneClick, trackQuoteCTA } from "@/lib/analytics";

const FloatingActions = () => {
  return (
    <>
      <a
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick("floating")}
        className="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp"
      >
        <MessageCircle size={28} />
      </a>
      <Link to="/contact" onClick={() => trackQuoteCTA("sticky-tab")} className="sticky-quote-tab" data-testid="sticky-quote-tab">
        <FileText size={14}/> GET A QUOTE
      </Link>
      <div className="mobile-bottom-bar" data-testid="mobile-bottom-bar">
        <a onClick={() => trackPhoneClick("mobile-bar")} href={`tel:${COMPANY.phones[0].replace(/\s/g,'')}`} className="py-4 flex items-center justify-center gap-2 text-white font-bold tracking-[.14em] text-sm bg-[#E8721C]">
          <Phone size={16}/> CALL
        </a>
        <a onClick={() => trackWhatsAppClick("mobile-bar")} href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="py-4 flex items-center justify-center gap-2 text-white font-bold tracking-[.14em] text-sm bg-[#25D366]">
          <MessageCircle size={16}/> WHATSAPP
        </a>
      </div>
    </>
  );
};

export default FloatingActions;
